(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pureease-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pe-root]').forEach((root) => {
    const money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });
    const quantityInput = root.querySelector('[data-pe-quantity-input]');
    const quantityOutput = root.querySelector('[data-pe-quantity-output]');
    const buttonPrice = root.querySelector('[data-pe-button-price]');
    const buyButton = root.querySelector('[data-pe-buy-now]');
    const errorBox = root.querySelector('[data-pe-error]');
    const promoPrice = Number(root.dataset.promoPrice || 0);
    let quantity = 1;

    const renderQuantity = () => {
      quantityInput.value = String(quantity);
      quantityOutput.textContent = String(quantity);
      buttonPrice.textContent = money.format((promoPrice * quantity) / 100);
    };

    root.querySelector('[data-pe-quantity-minus]')?.addEventListener('click', () => {
      quantity = Math.max(1, quantity - 1);
      renderQuantity();
    });

    root.querySelector('[data-pe-quantity-plus]')?.addEventListener('click', () => {
      quantity = Math.min(10, quantity + 1);
      renderQuantity();
    });

    root.querySelectorAll('[data-pe-thumbnail]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const main = root.querySelector('.pe-gallery__image');
        if (!main) return;
        main.src = thumb.dataset.src;
        main.removeAttribute('srcset');
        main.alt = thumb.dataset.alt || '';
        root.querySelectorAll('[data-pe-thumbnail]').forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
      });
    });

    buyButton?.addEventListener('click', async () => {
      const form = buyButton.closest('form');
      const variantId = Number(form.querySelector('[name="id"]').value);
      const label = buyButton.querySelector('[data-pe-buy-label]');
      const originalLabel = label.textContent;
      errorBox.hidden = true;
      buyButton.disabled = true;
      label.textContent = root.dataset.openingLabel;
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity }] })
        });
        if (!response.ok) throw new Error(root.dataset.addError);
        window.location.assign(`${window.Shopify.routes.root}checkout`);
      } catch (error) {
        errorBox.textContent = error.message || root.dataset.checkoutError;
        errorBox.hidden = false;
        buyButton.disabled = false;
        label.textContent = originalLabel;
      }
    });

    renderQuantity();
  });

  } catch(e) { console.error(e); }
})();
})();
